import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DeleteConfirmationModalComponent } from '../modals';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-education-table-component',
    templateUrl: './education-component.html',
    styleUrls: ['./education-component.scss']
})

export class EducationTableComponent implements OnInit {
    @Input() data_array : Array<any>;
    @Output() delete = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();

    constructor(private modalService: NgbModal) {
    	
    }

    ngOnInit() {}

    deleteAction(data){
        const modalRef = this.modalService.open(DeleteConfirmationModalComponent);
              const p1 = data.institute_id ? data.institute.institute_name_en : data.institute_name
              const p2 = data.major_id ? data.major.major_name_en : data.major_name
              modalRef.componentInstance.Title = " "+p1+"/"+p2;
              modalRef.result.then((result) => {
                    if(result.status)
                        this.delete.emit(data.id);
                  }).catch((error) => {
              });
        
    }

    editAction(data){
        this.edit.emit({... data});
    }

    getDegreeString(degree){
        switch (degree) {
            case "h_school":
                return "High School"
                break;
            case "p_school":
                return "Primary School"
                break;
            default:
                return degree;
                break;
        }
    }
}
